import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';

import { JBMViewModule } from "../../components/JBM/Views/jbmview.module";
import { SettingsRoutingModule } from './settings-routing.module';
import { SettingsComponent } from './settings.component';
import {LayoutModule} from '../../layout/layout.module';

@NgModule({
  declarations: [SettingsComponent],
    imports: [CommonModule, SettingsRoutingModule, SharedModule, JBMViewModule, LayoutModule]
})
export class SettingsModule { }
